export const LocalStorageKey = {
  token: 'accessToken',
  refreshToken: 'refreshToken',
  userId: 'userId',
  userPortals: 'userPortals',
  emailConfirmed: 'isEmailConfirmed',
  kycProfile: 'kycProfile',
  learnerProfileId: 'learnerProfileId',
  assignedModules: 'assignedModules',
}

// Handed from the payment dialog to the payment-confirmation route, which the
// gateway redirects to with only a reference in the query string.
export const PaymentSessionKey = {
  invoiceId: 'pendingPurchaseInvoiceId',
  reference: 'pendingPurchaseReference',
};

export const PaymentMessageType = 'driveright:payment-result';

export const DrivingSchoolPaymentSessionKey = {
  applicationId: 'pendingDrivingSchoolApplicationId',
  reference: 'pendingDrivingSchoolPaymentReference',
  applicationForReference: 'drivingSchoolPaymentApplication:',
};

export const DrivingSchoolPaymentMessageType = 'driveright:driving-school-payment-result';

export const placeholderImage = {
  course: 'placeholder/courses-placeholder.png',
  courseModule: 'placeholder/course-module-placeholder.png'
}
